import {
defineCustomElement,
MediaCaptionsRadioGroupElement
} from "vidstack/elements";

defineCustomElement(MediaCaptionsRadioGroupElement);